import { Card, Collapse, Button } from 'react-bootstrap'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { cardStyle } from './constants'

const ProgressDetail = ({
  detail,
  progressDetailCommand,
  setProgressDetailCommand
}) => {
  return (
    <Card style={cardStyle} className="mt-4">
      <div
        className="d-flex justify-content-between align-items-center cursor-pointer mb-3"
        onClick={() => {
          setProgressDetailCommand(!progressDetailCommand)
        }}
        style={{ cursor: 'pointer' }}
      >
        <h5 className="m-0 fw-bold text-dark" style={{ fontSize: '1rem' }}>
          PROGRESS DETAIL
        </h5>
        <Button variant="transparent" className="p-0 text-secondary">
          {progressDetailCommand ? (
            <ChevronUp size={16} />
          ) : (
            <ChevronDown size={16} />
          )}
        </Button>
      </div>
      <Collapse in={progressDetailCommand}>
        <div id="progress-collapse" className="mt-4 ms-3 position-relative">
          <div
            className="position-absolute"
            style={{
              top: '0',
              bottom: '0',
              left: '6px',
              borderLeft: '2px solid #e9ecef',
              zIndex: 0
            }}
          />
          {detail?.progress?.length > 0 ? (
            detail?.progress?.map((progress, index) => (
              <div
                key={index}
                className="d-flex align-items-start mb-3 position-relative"
                style={{ zIndex: 1 }}
              >
                <div
                  className="d-flex align-items-center justify-content-center bg-white"
                  style={{
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    border: '2px solid var(--primary-orange)',
                    marginTop: '4px',
                    marginRight: '1rem',
                    flexShrink: 0
                  }}
                >
                  <div
                    style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: 'var(--primary-orange)'
                    }}
                  />
                </div>
                <div className="w-100">
                  <div
                    className="text-secondary small mb-1"
                    style={{ fontSize: '0.75rem', marginTop: '2px' }}
                  >
                    {progress?.datetime || '-'}
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{ fontSize: '0.9rem' }}
                  >
                    {progress?.description}
                    {progress?.detail?.length > 0 && (
                      <ul
                        className="list-unstyled mt-2 mb-0"
                        style={{ marginLeft: '1rem' }}
                      >
                        {progress?.detail?.map((detailItem, idx) => (
                          <li
                            key={idx}
                            style={{
                              color: `${detailItem.color || 'black'}`,
                              fontSize: '0.85rem'
                            }}
                            className="mb-1"
                          >
                            {detailItem?.description}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-3 text-muted fst-italic">Data Empty!</div>
          )}
        </div>
      </Collapse>
    </Card>
  )
}

export default ProgressDetail
